import { Footer } from "@/components/admin-panel/footer";
import { Sidebar } from "@/components/admin-panel/sidebar";
import { useSidebar } from "@/hooks/use-sidebar";
import { cn } from "@/lib/utils";

export default function AdminPanelLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const sidebar = useSidebar();

  const { getOpenState, settings } = sidebar ?? {};

  if (!sidebar) return null;

  return (
    <>
      <Sidebar />

      <main
        className={cn(
          "bg-zinc-50 dark:bg-zinc-900 transition-[margin-left] ease-in-out duration-300 min-h-[calc(100vh-56px)]",
          !settings.disabled && (!getOpenState() ? "lg:ml-[90px]" : "lg:ml-72")
        )}
      >
        {children}
      </main>

      <footer
        className={cn(
          "transition-[margin-left] ease-in-out duration-300",
          !settings.disabled && (!getOpenState() ? "lg:ml-[90px]" : "lg:ml-72")
        )}
      >
        <Footer />
      </footer>
    </>
  );
}
